var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGwt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 -4 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "light",
    d: "M8.119 2.171a.19.19 0 0 0 0-.266L6.269.055a.19.19 0 0 0-.266 0L.054 6a.19.19 0 0 0 0 .266l5.948 5.948a.19.19 0 0 0 .266 0l1.85-1.85a.19.19 0 0 0 0-.266l-3.827-3.83a.19.19 0 0 1 0-.266l3.828-3.831ZM14 .054a.19.19 0 0 0-.267 0l-5.94 5.938a.19.19 0 0 0 0 .266l1.85 1.853a.19.19 0 0 0 .267 0l3.823-3.823a.19.19 0 0 1 .267 0L15.712 6a.19.19 0 0 1 0 .266l-3.828 3.828a.19.19 0 0 0 0 .266l1.85 1.85a.19.19 0 0 0 .267 0l5.945-5.945a.19.19 0 0 0 0-.266L14 .054Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwt);
export default __webpack_public_path__ + "static/media/gwt.5c6e05e19f882109b2b6bd815984fee8.svg";
export { ForwardRef as ReactComponent };